import SchemerModel from '../SchemerModel'
import { ReactElement } from 'react';

export const SCHEMER_FIELDS = Symbol("schemer.fields")

export const TABLE_FIELDS = Symbol('schemer.fields.table')
export const INPUT_FIELDS = Symbol('schemer.fields.input')
// const GRAPH_FIELDS = Symbol('schemer.graphFields')

export const DEFAULT_CELL_HEIGHT = 40
export const DEFAULT_HEADER_HEIGHT = 60

export type LabelFormatterFn = (propertyName: string, modelInstance: SchemerModel) => string|ReactElement
export interface LabelFormatterCmpProps {
  model: SchemerModel
  propertyName: string
}
export type LabelFormatterCmp = React.ElementType<LabelFormatterCmpProps>
export type LabelFormatter = LabelFormatterFn|LabelFormatterCmp|string

/**
 * Table Config
 */

// export type TableCellWidthGetter = (modelInstance: SchemerModel) => number
export type TableCellHeightGetter = (val: any, modelInstance?: SchemerModel) => number
// export type TableHeaderRenderer = (columnKey: string, row: SchemerModel) => string|ReactElement

export type TableConfig = {
  width?: number, //|TableCellWidthGetter,
  height?: number|TableCellHeightGetter,
  headerHeight?: number,
  header?: LabelFormatter, 
  canSort?: boolean,
  canStick?: boolean, 
  forceSticky?: boolean, // If `true`, `canStick` will be ignored
  canResize?: boolean,
  multiline?: boolean // Word wrap
}

export type ColumnsConfig = Map<string, TableConfig> // {[propName: string]: TableConfig}

export const DEFAULT_TABLE_CONFIG = {
  width: 300,
  height: DEFAULT_CELL_HEIGHT,
  headerHeight: DEFAULT_HEADER_HEIGHT,
  canSort: false,
  canStick: true,
  forceSticky: false,
  canResize: true,
  multiline: false
}

/**
 * Input Config
 */
export type OptionsGetter = (value: any, model: SchemerModel) => string[]

export type InputConfig = {
  required?: boolean
  validate?: (value: any) => string|null
  typeaheadOptions?: string[] | OptionsGetter,
  placeholder?: string
}

const DEFAULT_INPUT_CONFIG = {
  required: false,
  validate: () => null
}

export type DisplayFormatterFn = (value?: any) => any

// export interface FormatterCmpProps {
//   value?: any
//   row?: SchemerModel
//   columnKey: string
// }

export type DisplayFormatter = DisplayFormatterFn|React.ElementType

/**
 * Main Schemer field config shape
 */
export type FieldConfigBase = {
  label?: LabelFormatter
  description?: string
  formatDisplay?: DisplayFormatter
  formatExport?: (value: any) => string | number
  input?: boolean | InputConfig
  table?: boolean | TableConfig
  
}

export type ArrayConfig = FieldConfigBase & {
  $type: symbol
  $arrayOfType: symbol
}

interface Constructable<T> {
  new(initial: any, opts?: any) : T
}

export type ConstructableSchemerModel = Constructable<SchemerModel>

export type ModelConfig = FieldConfigBase & {
  model: ConstructableSchemerModel
}

export type FieldConfig = FieldConfigBase|ArrayConfig|ModelConfig

export type FieldsConfig = {[key: string]: FieldConfig}



export type ArrayConfigOutput = FieldConfigBase & {
  $arrayOfType: symbol
  $type: symbol
}

export type FieldConfigOutput = FieldConfig & {
  $type: symbol
}

export type FieldConfigsOutput = {[key: string]: FieldConfigOutput}


// export type TypedConfig = FieldConfig & {
//   $type: symbol
// }

// const DEFAULT_DISPLAYABLE_FORMATTER = (rawValue: string|number) : string => `DEFAULT FORMATTING (${rawValue})`
// export type DisplayFormatter = (rawValue: string|number) => string
export const DEFAULT_FIELD_CONFIG = {
  required: false,
  validate: () => null,
  formatDisplay: value => value && `${value}`,
  formatExport: value => value ? `${value}` : "",
  table: DEFAULT_TABLE_CONFIG,
  input: DEFAULT_INPUT_CONFIG
}